import React from 'react';
import PropTypes from 'prop-types';
import { mapObject, constant } from 'underscore';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withOverflowProp } from '@bingads-webui-react/with-overflow-prop';
import { Glyphicon, Tooltip, OverlayTrigger } from '@bingads-webui-react/primitive';
import { getEntityItemStyles } from './styles';

class EntityItem extends React.PureComponent {
  renderContent = () => {
    const {
      canEdit,
      tooltipPlacement,
      text,
    } = this.props;
    const renderEntityContent = ({
      forwardedRef,
      isTextOverflow,
    }) => (
      <div className="entity-content">
        <OverlayTrigger
          key={tooltipPlacement}
          placement={tooltipPlacement}
          overlay={
            <Tooltip
              id={tooltipPlacement}
              className={isTextOverflow ? '' : 'hide'}
            >
              {text}
            </Tooltip>
          }
        >
          <div className="entity-text" ref={forwardedRef}>{text}</div>
        </OverlayTrigger>
        {canEdit ? (
          <Glyphicon
            className="entity-icon"
            glyph="ba-Edit"
          />
        ) : null}
      </div>
    );

    const EntityContentWithOverflow = withOverflowProp(renderEntityContent);
    return (<EntityContentWithOverflow />);
  };

  render() {
    const {
      classes,
      renderEntityItem,
      label,
      renderContent,
      onClick,
      canEdit,
      ariaLabel,
    } = this.props;
    const className = `${classes.entityItem} entity-item`;

    if (renderEntityItem) {
      return (
        <div className={className}>
          { renderEntityItem() }
        </div>
      );
    }

    return (
      <div
        className={className}
        {...(canEdit && onClick ? {
          onClick,
          onKeyDown: submitEvent(event => onClick(event)),
          tabIndex: 0,
          'aria-label': ariaLabel,
          role: 'button',
        } : {})}
      >
        <span className="entity-label">{label}</span>
        { renderContent ? renderContent(this.props) : this.renderContent()}
      </div>
    );
  }
}

EntityItem.propTypes = {
  classes: PropTypes.shape(mapObject(
    getEntityItemStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  renderEntityItem: PropTypes.func,
  label: PropTypes.string,
  text: PropTypes.string,
  renderContent: PropTypes.func,
  onClick: PropTypes.func,
  canEdit: PropTypes.bool,
  ariaLabel: PropTypes.string,
  tooltipPlacement: PropTypes.string,
};

EntityItem.defaultProps = {
  text: '',
  renderEntityItem: null,
  renderContent: null,
  onClick: null,
  canEdit: true,
  label: '',
  ariaLabel: '',
  tooltipPlacement: 'top',
};

export const StyledEntityItem = withDefaultStyles(EntityItem, getEntityItemStyles);
